import clsx from "clsx";
import { type ReactNode } from "react";
import { createPluggable } from "pluggable-react";
import Status from "../Status/Status";
import styles from "./ErrorStatus.module.scss";

export interface ErrorStatusProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    children?: ReactNode;
}

const DefaultErrorStatus = (props: ErrorStatusProps) => {
    const { className, children, ...rest } = props;

    return (
        <Status className={clsx(styles.errorStatus, className)} data-deci-error-status="true" {...rest}>
            {children || <Status.Content>Error</Status.Content>}
        </Status>
    );
};

const ErrorStatus = createPluggable<ErrorStatusProps>("deci.errorStatus", DefaultErrorStatus);

export default Object.assign(ErrorStatus, {
    Graphic: Status.Graphic,
    Title: Status.Title,
    Content: Status.Content,
});
